
import { 
    userListStatistics, 
    userLabelStatistics, 
    homeDistanceStatistic, 
    potentialUserStatistics, 
    sourceTypeStatistics, 
    userAgeStatistic, 
    userGroupStatistics, 
    saveGroup,
    findUserInfoList,
    labelSaveLable,
    labelSelectList,
    labelDeleteLabel,
    groupDeleteGroup,
    groupSelectList,
    groupDeleteUserGroup,
    findCompanyPosition,
    findIndustry,
    saveUserInfo,
    selectByPhone,
    selectByUserPk,
    vipTypeList,
    cardTypeCfgList,
    deleteUserLabel
} from "../../../api/user"

// 客户管理头部数据统计
export const _userListStatistics = (options) => userListStatistics(options)


// 客户标签统计
export const _userLabelStatistics = (options) => userLabelStatistics(options)

// 客户距离统计
export const _homeDistanceStatistic = (options) => homeDistanceStatistic(options)

// 潛在客户统计
export const _potentialUserStatistics = (options) => potentialUserStatistics(options)

// 客户来源
export const _sourceTypeStatistics = (options) => sourceTypeStatistics(options)

// 客户年龄
export const _userAgeStatistic = (options) => userAgeStatistic(options)

// 客户群组
export const _userGroupStatistics = (options) => userGroupStatistics(options)

// 保存编辑群组
export const _saveGroup = (options:any) => saveGroup(options)

// 保存编辑群组
export const _findUserInfoList = (options:any) => findUserInfoList(options)

// 保存编辑标签
export const _labelSaveLable = (options:any) => labelSaveLable(options)

// 查询全部标签
export const _labelSelectList = (options:any) => labelSelectList(options)

// 刪除标签
export const _labelDeleteLabel = (options:any) => labelDeleteLabel(options)

// 删除客户标签
export const _deleteUserLabel = (options:any) => deleteUserLabel(options)

// 删除群组
export const _groupDeleteGroup = (options:any) => groupDeleteGroup(options)

// 查询全部群组
export const _groupSelectList = (options:any) => groupSelectList(options)

// 删除客户群组
export const _groupDeleteUserGroup = (options:any) => groupDeleteUserGroup(options)

// 查询职位数据列表
export const _findCompanyPosition = () => findCompanyPosition()

// 查询行业数据列表
export const _findIndustry = () => findIndustry()

// 保存客户信息
export const _saveUserInfo = (options:any) => saveUserInfo(options)

// 手机号精确查询客户信息
export const _selectByPhone = (options:any) => selectByPhone(options)

// 客户PK查询客户信息
export const _selectByUserPk = (options:any) => selectByUserPk(options)

// 会员类型列表
export const _vipTypeList = (options:any) => vipTypeList(options)

// 会员类型列表
export const _cardTypeCfgList = () => cardTypeCfgList()
